// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__Hwxh4","card":"styles_card__2hQQM","actions":"styles_actions__20VfJ","form":"styles_form__1kBT6"};